import React from 'react';

import { graphql, withApollo, compose } from 'react-apollo';
import {
  Upload,
  Row,
  Col,
  Button,
  Input,
  Select,
  message,
  DatePicker,
  Checkbox,
  Tooltip,
  notification,
} from 'antd/lib';
import moment from 'moment';
import { Modal } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';
import Loading from '../../common/Loading';
import _ from 'lodash';
import { errorService } from '../../../graphql/utils/utils';
import convertBase64toBlob from '../../../components/common/documentos/convertBase64toBlob';

const Option = Select.Option;
const { TextArea } = Input;
const confirm = Modal.confirm;

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getTraspasoPorId from '../../../graphql/querys/rrhh/getTraspasoPorId.graphql';
import getUsuariosPorOrganismo from '../../../graphql/querys/auth/getUsuariosPorOrganismo.graphql';
import crearCertificacionTraspaso from '../../../graphql/mutations/rrhh/crearCertificacionTraspaso.graphql';
import updateCertificacionTraspaso from '../../../graphql/mutations/rrhh/updateCertificacionTraspaso.graphql';
import eliminarCertificacionTraspaso from '../../../graphql/mutations/rrhh/eliminarCertificacionTraspaso.graphql';
import getCertificacionesTraspasoPorIdTraspaso from '../../../graphql/querys/rrhh/getCertificacionesTraspasoPorIdTraspaso.graphql';
import subirResolucionPDF from '../../../graphql/mutations/rrhh/subirResolucionPDF.graphql';
import getResolucionBase64 from '../../../graphql/querys/rrhh/getResolucionBase64.graphql';

import TablaCertificacionesTraspaso from './certificaciones/TablaCertificacionesTraspaso';

@compose(
  graphql(getTraspasoPorId, {
    name: 'getTraspasoPorId',
  }),
  graphql(getCertificacionesTraspasoPorIdTraspaso, {
    name: 'getCertificacionesTraspasoPorIdTraspaso',
  }),
  graphql(getOrganismos, {
    name: 'getOrganismos',
  }),
  graphql(crearCertificacionTraspaso, {
    name: 'crearCertificacionTraspaso',
  }),
  graphql(updateCertificacionTraspaso, {
    name: 'updateCertificacionTraspaso',
  }),
  graphql(eliminarCertificacionTraspaso, {
    name: 'eliminarCertificacionTraspaso',
  }),
  graphql(subirResolucionPDF, {
    name: 'subirResolucionPDF',
  })
)
class PrecargarTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      traspaso: {},
      reemplazante: '',
      origen: '',
      destino: '',
      fechaDesde: '',
      fechaHasta: '',
      normativa: '',
      pagoViaticos: false,
      observacionCarga: '',
      certificaciones: [],
      listaOrganismos: [],
      listaUsuarios: [],
      file: [],
      loaded: false,
      loading: true,
      disabledForm: false,
      fechaDesdeValidada: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params) {
      let _id = this.props.match.params.id;

      if (_id) {
        this.props.client
          .query({
            query: getTraspasoPorId,
            variables: { _id: _id },
            fetchPolicy: 'network-only',
          })
          .then(res => {
            const traspaso = res.data.getTraspasoPorId;
            // console.log('TRASPASO LLEGA ==>', traspaso);

            this.setState({
              ...this.state,
              fechaDesde: moment(traspaso.fechaReal),
              traspaso: traspaso,
              reemplazante: traspaso.usuarioEntrante._id,
              origen: traspaso.usuarioEntrante.organismo._id,
              destino: traspaso.usuarioSaliente.organismo._id,
            });

            this.props.client
              .query({
                query: getUsuariosPorOrganismo,
                variables: {
                  idOrganismo: traspaso.organismo._id,
                },
              })
              .then(res => {
                this.setState(
                  {
                    ...this.state,
                    listaUsuarios: res.data.getUsuariosPorOrganismo,
                  },
                  () => {
                    // LLamo al metodo que busca las certificaciones de este traspaso
                    this.getCertificaciones();
                  }
                );
              })
              .catch(err => {
                console.log(
                  'ERROR A LA HORA DE BUSCAR USUARIOS POR ORGANISMO!'
                );
                console.log(err);

                let yo = this;
                Modal.error({
                  title:
                    'Error en la obtencion de los usuarios de un organismo',
                  content:
                    'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                  onOk() {
                    yo.props.history.push('/');
                  },
                });
              });
          })
          .catch(err => {
            console.log('Error en la busqueda del traspaso');
            console.log(err);

            Modal.error({
              title: 'Error en la busqueda del traspaso',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    }
  }

  getCertificaciones() {
    this.props.client
      .query({
        query: getCertificacionesTraspasoPorIdTraspaso,
        variables: {
          idTraspaso: this.state.traspaso._id,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        // console.log('response get certificaciones =>', res);
        const certificaciones =
          res.data.getCertificacionesTraspasoPorIdTraspaso;

        // busco si tiene alguna certificacion en estado precargado
        // en ese caso vamos a desabilitar el formulario para que no cargue una nueva
        const tienePrecargado = certificaciones.some(
          cert => cert.estado === 'PRECARGADO'
        );

        // si ya hay certificaciones cargadas seteo la fechaHasta de la ultima certificacion
        if (certificaciones.length > 0) {
          const fechaHastaUltimoElemento = moment(
            certificaciones[certificaciones.length - 1].fechaHasta
          );
          const fechaValida = fechaHastaUltimoElemento.add(1, 'day'); // incremento la fecha al dia siguiente
          this.setState({
            ...this.state,
            fechaDesdeValidada: fechaValida.startOf('day'),
          });
        }

        this.setState({
          ...this.state,
          loading: false,
          certificaciones,
          disabledForm: tienePrecargado,
        });
      })
      .catch(err => {
        console.log('Error en la busqueda de las Certificaciones');
        console.log(err);

        Modal.error({
          title: 'Error en la busqueda las Certificaciones',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      ...this.state,
      loading: true,
    });
    if (
      this.state.file.length > 0 &&
      this.state.fechaDesde != '' &&
      this.state.fechaHasta != ''
    ) {
      // console.log('el estado esta asi ==>', this.state);
      const fechaDesde = this.state.fechaDesde.toDate();
      const fechaHasta = this.state.fechaHasta.toDate();

      let objInsert = {
        idReemplazante: this.state.reemplazante,
        idOrigen: this.state.origen,
        idDestino: this.state.destino,
        fechaDesde,
        fechaHasta,
        normativa: this.state.normativa.toUpperCase(),
        pagoViaticos: this.state.pagoViaticos,
        observacionCarga: this.state.observacionCarga,
        numeroTraspaso: this.state.traspaso.numero,
      };

      // creo certificacion nueva
      this.props
        .crearCertificacionTraspaso({
          variables: {
            idTraspaso: this.state.traspaso._id,
            certificacionTraspaso: objInsert,
          },
          fetchPolicy: 'no-cache',
        })
        .then(res => {
          // console.log('Respuesta crearCertificacionTraspaso', res);
          message.success('Certificacion cargada correctamente');

          let idCert = res.data.crearCertificacionTraspaso._id;

          // Guardo la resolucion
          this.props
            .subirResolucionPDF({
              variables: {
                resolucion: {
                  idCertificacion: idCert,
                },
                archivo: this.state.file[0],
              },
            })
            .then(res => {
              // console.log('Respuesta subir resolucion', res);
              this.setState(
                {
                  // limpio los inputs
                  ...this.state,
                  fechaDesde: '',
                  fechaHasta: '',
                  normativa: '',
                  pagoViaticos: false,
                  observacionCarga: '',
                  file: [],
                  loaded: false,
                },
                () => {
                  // Actualizo la lista de certificaciones
                  this.getCertificaciones();
                  this.props.history.push('/rrhh/traspasos');
                }
              );
            })
            .catch(err => {
              console.log('ERROR AL SUBIR LA RESOLUCIÓN');
              console.log(err);
            });
        })
        .catch(err => {
          console.log('ERROR AL SUBIR LA CERTIFICACION DE TRASPASO');
          console.log(err);
          Modal.error({
            title: 'Error al guardar los datos',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
          this.setState({
            ...this.state,
            loading: false,
          });
        });
    } else {
      message.error('No seleccionó un archivo de resolución');
      this.setState({
        ...this.state,
        loading: false,
      });
    }
  }

  eliminar = idCertificacion => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta certificacion del Traspaso?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.setState({
          ...yo.state,
          loading: true,
        });
        yo.props
          .eliminarCertificacionTraspaso({
            variables: { _id: idCertificacion },
          })
          .then(res => {
            // console.log('La respuesta del delete fue....', res);

            // Actualizo la lista de certificaciones
            yo.getCertificaciones();

            let id = res.data.eliminarCertificacionTraspaso;

            if (id) {
              notification.warning({
                message: 'Certificacion eliminada',
                description: 'Se ha eliminado la certificacion exitosamente',
              });
            }
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar la certificacion'
            );
            console.log(err);

            errorService(err, {
              idCertificacion,
            });

            Modal.error({
              title: 'Error en la eliminacion de la certificacion del traspaso',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  getBase64 = archivoId => {
    this.props.client
      .query({
        query: getResolucionBase64,
        variables: {
          archivo: archivoId,
        },
      })
      .then(res => {
        // console.log('response getBase64', res);
        return this.generatePDF(archivoId, res.data.getResolucionBase64);
      })
      .catch(err => {
        console.log('ERROR AL OBTENER EL LINK');
        console.log(err);
      });
  };

  generatePDF(archivoId, data) {
    const base64PdfBlob = convertBase64toBlob(data, 'application/pdf');
    const filePdf = URL.createObjectURL(base64PdfBlob);
    window.open(filePdf);
  }

  render() {
    const uploadProps = {
      accept: 'application/pdf',
      listType: 'picture',

      beforeUpload: file => {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
          message.error(`${file.name} no es un archivo PDF`);
        }
        // TRANSFORMAR ARCHIVO
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          file.base64 = e.target.result;
        };

        this.setState({ file: [file], loaded: true });
        return false;
      },
      fileList: this.state.file,
      onRemove: file => {
        this.setState({ file: [], loaded: false });
      },
    };

    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <h2 style={{ textAlign: 'center', marginTop: 20 }}>Certificación</h2>
        <Form encType="multipart/form-data" onSubmit={this.handleSubmit}>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Reemplazante: </h3>
                <Select
                  required
                  showSearch
                  id="reemplazante"
                  placeholder="Seleccione el reemplazante"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={this.state.reemplazante}
                  onChange={e =>
                    this.setState({
                      ...this.state,
                      reemplazante: e.target.value,
                    })
                  }
                  disabled={true}
                >
                  {this.state.listaUsuarios &&
                    this.state.listaUsuarios.map(usuario => (
                      <Select.Option key={usuario._id}>
                        {usuario.nombre + ' ' + usuario.apellido}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Organismo de origen: </h3>
                <Select
                  showSearch
                  id="origen"
                  placeholder="Seleccione el organismo de origen"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  defaultValue={this.state.origen}
                  onSelect={value => {
                    this.setState({
                      ...this.state,
                      origen: value,
                    });
                  }}
                  disabled={this.state.disabledForm}
                >
                  {this.props.getOrganismos.getOrganismos &&
                    this.props.getOrganismos.getOrganismos.map(organismo => (
                      <Select.Option key={organismo._id}>
                        {organismo.nombre}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Organismo destino: </h3>
                <Select
                  showSearch
                  id="destino"
                  placeholder="Seleccione el organismo de destino"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={this.state.destino}
                  onSelect={value => {
                    this.setState({
                      ...this.state,
                      destino: value,
                    });
                  }}
                  disabled
                >
                  {this.props.getOrganismos.getOrganismos &&
                    this.props.getOrganismos.getOrganismos.map(organismo => (
                      <Select.Option key={organismo._id}>
                        {organismo.nombre}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Fecha desde: </h3>
                <DatePicker
                  showTime={{
                    minuteStep: 10,
                    format: 'HH:mm',
                  }}
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Seleccionar Fecha y Hora"
                  style={{ color: '#000000', width: 270 }}
                  defaultValue={
                    this.state.fechaDesdeValidada
                      ? this.state.fechaDesdeValidada
                      : this.state.fechaDesde
                  }
                  onChange={fecha => {
                    this.setState({
                      ...this.state,
                      fechaDesde: moment(fecha),
                    });
                  }}
                  disabledDate={fecha => {
                    if (this.state.fechaDesdeValidada) {
                      return fecha && fecha < this.state.fechaDesdeValidada;
                    } else {
                      return fecha && fecha < this.state.traspaso.fechaReal;
                    }
                  }}
                  disabled={this.state.disabledForm}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Fecha hasta: </h3>
                <DatePicker
                  showTime={{
                    minuteStep: 10,
                    format: 'HH:mm',
                  }}
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Seleccionar Fecha y Hora"
                  style={{ color: '#000000', width: 270 }}
                  defaultValue={this.state.fechaHasta}
                  onChange={fecha => {
                    this.setState({
                      ...this.state,
                      fechaHasta: moment(fecha),
                    });
                  }}
                  disabledDate={fecha => {
                    if (this.state.fechaDesdeValidada) {
                      return fecha && fecha < this.state.fechaDesdeValidada;
                    } else {
                      return fecha && fecha < this.state.fechaDesde;
                    }
                  }}
                  disabled={this.state.disabledForm}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Normativa: </h3>
                <Input
                  required
                  id="normativa"
                  value={this.state.normativa}
                  placeholder="Complete con la normativa"
                  onChange={e =>
                    this.setState({
                      ...this.state,
                      normativa: e.target.value,
                    })
                  }
                  disabled={this.state.disabledForm}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Pago viáticos: </h3>
                <Checkbox
                  id="viaticos"
                  checked={this.state.pagoViaticos}
                  onChange={e => {
                    this.setState({
                      ...this.state,
                      pagoViaticos: e.target.checked,
                    });
                  }}
                  disabled={this.state.disabledForm}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Observaciones: </h3>
                <TextArea
                  id="observacionCarga"
                  value={this.state.observacionCarga}
                  placeholder="Complete con sus observaciones"
                  onChange={e =>
                    this.setState({
                      ...this.state,
                      observacionCarga: e.target.value,
                    })
                  }
                  disabled={this.state.disabledForm}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Resolucion: </h3>
                <Upload {...uploadProps} required>
                  <Button
                    disabled={this.state.loaded || this.state.disabledForm}
                  >
                    <Icons.UploadOutlined />
                    Seleccionar Documento PDF
                  </Button>
                </Upload>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 20, marginBottom: 20 }}>
            <Col style={{ margin: 'auto' }}>
              {this.state.disabledForm && (
                <span style={{ marginRight: 5 }}>
                  <Tooltip
                    placement="left"
                    title="Debe visar la ultima certificacion antes de cargar una nueva"
                  >
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              )}
              <Button
                disabled={this.state.disabledForm}
                type="primary"
                htmlType="submit"
              >
                Guardar
              </Button>

              <Button
                style={{ marginLeft: 20 }}
                type="danger"
                onClick={() => this.props.history.push('/rrhh/traspasos')}
              >
                Atras
              </Button>
            </Col>
          </Row>
          <Row type={'flex'} justify={'center'}>
            <Col span={14}>
              <TablaCertificacionesTraspaso
                certificacionesTraspaso={this.state.certificaciones}
                total={this.state.certificaciones.length}
                history={this.props.history}
                eliminarCertificacion={this.eliminar}
                getBase64={this.getBase64}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default withApollo(PrecargarTraspaso);
